var gglMaps = require("../../common/pc/js/gglMaps");

$(function() {
	var ShopMap_elm = $('#shopMap_id');
	var ShopMap_conf = ShopMap_elm.data('map_conf');
	var ShopMk_conf = ShopMap_elm.data('mk_conf');
	gglMaps.map_view(ShopMap_conf,'#shopMap__canvas_id',ShopMk_conf);
});

// デフォルトの POI をクリック無効に(要無名関数)
(function fixInfoWindow() {
	var set = google.maps.InfoWindow.prototype.set;
	google.maps.InfoWindow.prototype.set = function(key, val) {
		if (key === "map") {
			if (! this.get("noSupress")) {
				return;
			}
		}
		set.apply(this, arguments);
	};
})();



/*****************
 ** WEBPACK FOOTER
 ** ./js/_access.js
 ** module id = 0
 ** module chunks = 1
 **/